
import React from 'react';

export const MusicSheetIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M19,3H5C3.9,3,3,3.9,3,5v14c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2V5C21,3.9,20.1,3,19,3z M12,17c-1.65,0-3-1.35-3-3s1.35-3,3-3s3,1.35,3,3S13.65,17,12,17z M17,8h-5V6h5V8z M17,12h-5v-2h5V12z"/>
  </svg>
);
